import { motion } from "framer-motion";
import { AlertCircle, TrendingDown, UserX, XCircle } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

const painPoints = [
  {
    icon: UserX,
    title: "Falta cliente na sua empresa",
    description: "Dias sem nenhum contato novo, semanas sem fechar negócios.",
  },
  {
    icon: TrendingDown,
    title: "Seu faturamento varia todo mês",
    description: "Meses bons seguidos de meses péssimos, sem previsibilidade.",
  },
  {
    icon: AlertCircle,
    title: "Depende de indicação",
    description: "Sem controle sobre a entrada de clientes, na esperança de alguém indicar.",
  },
  {
    icon: XCircle,
    title: "Já tentou anúncios e não teve resultado",
    description: "Investiu dinheiro e não viu retorno, sentindo que marketing não funciona.",
  },
];

export const PainPointsSection = () => {
  return (
    <section
      id="dores"
      data-testid="pain-points-section"
      className="relative py-24 lg:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#F97316] mb-4 block">
            Você se identifica?
          </span>
          <h2 className="font-outfit font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
            Se você sente que...
          </h2>
        </motion.div>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-16">
          {painPoints.map((point, index) => (
            <motion.div
              key={index}
              {...fadeInUp}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              data-testid={`pain-point-${index}`}
              className="pain-card glass-card rounded-xl p-8 hover:border-[#F97316]/30 transition-colors duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-[#F97316]/10 border border-[#F97316]/20 flex items-center justify-center">
                  <point.icon className="w-6 h-6 text-[#F97316]" />
                </div>
                <div>
                  <h3 className="font-outfit font-semibold text-xl text-white mb-2">
                    {point.title}
                  </h3>
                  <p className="text-[#A1A1AA] leading-relaxed">
                    {point.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Conclusion */}
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <div className="inline-block glass-card rounded-2xl p-8 lg:p-10 max-w-2xl">
            <p className="font-outfit text-xl lg:text-2xl text-white mb-2">
              Então o problema <span className="text-[#F97316]">não é o marketing</span>...
            </p>
            <p className="font-outfit text-2xl lg:text-3xl font-bold text-white">
              é a <span className="text-gradient-blue">estratégia</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
